<template>
    <div class="warning window coingecko-incident-notice" v-if="IS_COINGECKO_INCIDENT_ONGOING">
        The Curve website uses Coingecko to display some prices, and Coingecko is currently having <a href="https://status.coingecko.com/" target="_blank" rel="noopener noreferrer">technical issues</a>: some parts of the website might not load correctly at the moment. This is of course unrelated to smart contracts and has no incidence on them.
    </div>
</template>

<script>
    import { IS_COINGECKO_INCIDENT_ONGOING } from '@/constants/AppConstants';

	export default {
		data: () => ({
            IS_COINGECKO_INCIDENT_ONGOING,
		}),
	}
</script>

<style scoped>
    .coingecko-incident-notice {
        font-style: italic;
    }
</style>
